import { toObservable } from '@angular/core/rxjs-interop';
import { submissionDetailTokenizer } from '@data-access/submissions/store';
import { filter, firstValueFrom } from 'rxjs';

export const submissionDetailResolver = async () => {
  const _submissionDetailTokenizer = submissionDetailTokenizer();
  return await firstValueFrom(
    toObservable(_submissionDetailTokenizer.$submission).pipe(
      filter(
        (submission) => !!submission && Object.keys(submission).length > 0,
      ),
    ),
  );
};
